import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chatbot.remote');
import { ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

const CHAT_ORIGIN = 'https://nanochat.wizide.com';
const CHANNEL = 'nanofab.floating-chat';
const ETCH_MOCKUP_PATH = '/agent/screen-adjust?group=' + encodeURIComponent('검색') + '&menu=' + encodeURIComponent('데이터 검색');
const NAVIGATION_PATHS = ['/knowledge/document-results', '/dashboard', '/dashboard2', '/access'];

@Component({
    selector: 'wiz-component-chatbot-remote',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chatbot.remote/view.scss */
:host {
  display: block;
}

.nf-floating-chat {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 90;
  pointer-events: none;
}

.nf-floating-chat > * {
  pointer-events: auto;
}

.nf-floating-chat-panel[hidden] {
  display: none !important;
}

.nf-floating-chat-launcher {
  position: relative;
  display: flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #b8cae1;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
  cursor: pointer;
}

.nf-floating-chat-launcher:hover {
  border-color: #2e6fae;
  box-shadow: 0 20px 52px rgba(46, 111, 174, 0.28);
  transform: translateY(-2px);
}

.nf-floating-chat-launcher:focus-visible,
.nf-remote-chat-status button:focus-visible,
.nf-floating-chat-resize-handle:focus-visible {
  outline: 3px solid rgba(46, 111, 174, 0.24);
  outline-offset: 3px;
}

.nf-floating-chat-launcher-face {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

.nf-floating-chat-launcher-dot {
  position: absolute;
  right: 3px;
  bottom: 3px;
  display: inline-flex;
  width: 21px;
  min-width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #153e66;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.nf-floating-chat-panel {
  position: relative;
  display: grid;
  width: min(560px, 100vw - 32px);
  height: min(760px, 100vh - 44px);
  height: min(760px, 100dvh - 44px);
  max-height: min(760px, 100vh - 44px);
  max-height: min(760px, 100dvh - 44px);
  grid-template-rows: minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid #c8d6e8;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

iframe {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  border: 0;
}

.is-resizing iframe {
  pointer-events: none;
}

.nf-remote-chat-status {
  position: absolute;
  inset: 12px 14px auto;
  margin: 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f4f7fb;
  color: #64748b;
  font-size: 12px;
}

.nf-remote-chat-status p {
  margin: 0 0 8px;
}

.nf-remote-chat-status div {
  display: flex;
  gap: 8px;
}

.nf-remote-chat-status button {
  padding: 5px 10px;
  border: 1px solid #c8d6e8;
  border-radius: 6px;
  background: #fff;
  color: #153e66;
  cursor: pointer;
}

.nf-floating-chat-resize-handle {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 3;
  display: grid;
  width: 25px;
  height: 25px;
  cursor: nwse-resize;
  place-content: center;
  gap: 2px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.88);
  touch-action: none;
}

.nf-floating-chat-resize-handle span {
  display: block;
  height: 1px;
  border-radius: 999px;
  background: #64748b;
  transform: rotate(-45deg);
}

.nf-floating-chat-resize-handle span:nth-child(1) {
  width: 6px;
}

.nf-floating-chat-resize-handle span:nth-child(2) {
  width: 10px;
}

.nf-floating-chat-resize-handle span:nth-child(3) {
  width: 14px;
}

:host-context([data-theme=dark]) .nf-floating-chat-panel,
:host-context([data-theme=dark]) .nf-remote-chat-status button {
  background: #0b192b;
  border-color: #263c54;
  color: #cbd5e1;
}

:host-context([data-theme=dark]) .nf-remote-chat-status {
  background: #15283e;
  color: #cbd5e1;
}

@media (max-width: 640px) {
  .nf-floating-chat {
    right: 12px;
    bottom: 14px;
    left: 12px;
  }
  .nf-floating-chat-launcher {
    margin-left: auto;
  }
  .nf-floating-chat-panel {
    width: 100%;
    height: calc(100vh - 28px);
    height: calc(100dvh - 28px);
    max-height: calc(100vh - 28px);
    max-height: calc(100dvh - 28px);
    border-radius: 14px;
  }
  .nf-floating-chat-resize-handle {
    display: none;
  }
}
@media print {
  .nf-floating-chat {
    display: none;
  }
}
.nf-etch-scenario-loading {
  position: fixed;
  top: 88px;
  left: 50%;
  z-index: 89;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: calc(100vw - 32px);
  padding: 12px 18px;
  transform: translateX(-50%);
  border: 1px solid #c8d6e8;
  border-radius: 12px;
  background: #ffffff;
  color: #153e66;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.14);
  font-size: 14px;
  pointer-events: none;
}

.nf-etch-scenario-spinner {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border: 2px solid #c8d6e8;
  border-top-color: #2e6fae;
  border-radius: 50%;
  animation: nf-etch-scenario-spin 0.8s linear infinite;
}

@keyframes nf-etch-scenario-spin {
  to {
    transform: rotate(360deg);
  }
}
:host-context([data-theme=dark]) .nf-etch-scenario-loading {
  background: #0b192b;
  border-color: #263c54;
  color: #cbd5e1;
}

@media (prefers-reduced-motion: reduce) {
  .nf-etch-scenario-spinner {
    animation: none;
  }
}`],
})
export class ComponentChatbotRemoteComponent implements OnInit, OnDestroy {
    @ViewChild('remoteChatFrame') private frame?: ElementRef<HTMLIFrameElement>;
    public open = false;
    public frameCreated = false;
    public connected = false;
    public status = '챗봇 연결을 확인하고 있습니다.';
    public frameUrl: SafeResourceUrl;
    public width = 560;
    public height = 760;
    public resizing = false;
    public scenarioLoading = false;
    private instanceId = '';
    private destroyed = false;
    private readonly receivedResultIds = new Set<string>();
    private readonly pendingResults: any[] = [];
    private scenarioDeliverySequence = 0;
    private readonly scenarioRequestIds = new Set<string>();
    private preparedScenarioQuery: any = null;
    private scenarioPreloadImages: HTMLImageElement[] = [];
    private scenarioFallbackTimer: any;
    private scenarioFallbackExpired = false;
    private scenarioNavigationCount = 0;
    private readonly sizeKey = 'nanofab.floating-chat.size.v1';
    private routerSubscription: any;
    private themeObserver?: MutationObserver;
    private connectionTimer: any;
    private handshakeTimer: any;
    private resizePointer: number | null = null;
    private resizeStart: { x: number; y: number; width: number; height: number } | null = null;
    private resizeHandle: HTMLElement | null = null;
    private readonly resizeMove = (event: PointerEvent) => this.moveResize(event);
    private readonly resizeEnd = (event: PointerEvent) => this.finishResize(event);

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        this.prepareFrameUrl();
        this.restoreSize();
        this.routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this.scenarioLoading && !(this.scenarioNavigationCount > 0 && this.isEtchMockupPath())) this.cancelScenarioQuery();
                this.sendHostContext();
            }
        });
        this.themeObserver = new MutationObserver(() => this.sendHostContext());
        this.themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
        await this.service.init();
    }

    private prepareFrameUrl() {
        const random = new Uint8Array(16);
        window.crypto.getRandomValues(random);
        this.instanceId = 'nfcb-' + Array.from(random).map(value => value.toString(16).padStart(2, '0')).join('');
        this.frameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(CHAT_ORIGIN + '/');
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.cancelScenarioQuery();
        this.scenarioRequestIds.clear();
        this.receivedResultIds.clear();
        this.pendingResults.length = 0;
        this.routerSubscription?.unsubscribe();
        this.themeObserver?.disconnect();
        window.clearTimeout(this.connectionTimer);
        window.clearInterval(this.handshakeTimer);
        this.finishResize();
    }

    public async toggleChat(event?: Event) {
        event?.stopPropagation();
        this.open = !this.open;
        if (this.open) {
            this.frameCreated = true;
            this.clampSize();
        } else {
            this.finishResize();
        }
        await this.service.render();
        if (this.open) this.beginHandshake();
        else {
            window.clearTimeout(this.connectionTimer);
            window.clearInterval(this.handshakeTimer);
        }
    }

    public async closeChat(event?: Event) {
        event?.stopPropagation();
        this.finishResize();
        window.clearTimeout(this.connectionTimer);
        window.clearInterval(this.handshakeTimer);
        this.open = false;
        await this.service.render();
    }

    public frameLoaded() { this.beginHandshake(); }

    private beginHandshake() {
        window.clearInterval(this.handshakeTimer);
        window.clearTimeout(this.connectionTimer);
        this.sendHostContext();
        if (this.connected || this.destroyed) return;
        this.handshakeTimer = window.setInterval(() => {
            if (this.open && !this.connected && !this.destroyed) this.sendHostContext();
        }, 250);
        this.connectionTimer = window.setTimeout(() => {
            if (this.connected || this.destroyed) return;
            window.clearInterval(this.handshakeTimer);
            this.status = '챗봇 연결을 확인하지 못했습니다. 잠시 후 다시 열어 주세요.';
            void this.service.render();
        }, 12000);
    }

    @HostListener('window:message', ['$event'])
    public receiveMessage(event: MessageEvent) {
        const value = event.data;
        if (this.destroyed || event.origin !== CHAT_ORIGIN
            || !this.frame?.nativeElement.contentWindow
            || event.source !== this.frame.nativeElement.contentWindow
            || !this.validMessage(value)) return;
        if (value.type === 'READY') {
            this.connected = true;
            this.status = '';
            window.clearTimeout(this.connectionTimer);
            window.clearInterval(this.handshakeTimer);
            this.sendHostContext();
            const pending = this.pendingResults.splice(0);
            pending.forEach(result => this.publishResult(result));
            if (this.scenarioFallbackExpired) void this.publishScenarioFallback();
            void this.service.render();
        } else if (value.type === 'QUERY_SUBMITTED') {
            const requestId = value.requestId || value.payload.requestId;
            if (!this.isEtchScenarioQuestion(value.payload.question) || this.scenarioRequestIds.has(requestId)
                || this.receivedResultIds.has(requestId)) return;
            this.scenarioRequestIds.add(requestId);
            if (this.scenarioRequestIds.size > 200) {
                this.scenarioRequestIds.delete(this.scenarioRequestIds.values().next().value);
            }
            const query = { source: 'remote-floating-chat', question: value.payload.question.trim(), requestId };
            this.cancelScenarioQuery();
            this.prepareScenarioQuery(query);
        } else if (value.type === 'CONVERSATION_RESET') {
            this.cancelScenarioQuery();
            this.pendingResults.length = 0;
        } else if (value.type === 'RESULT') {
            const requestId = value.requestId || value.payload.requestId || '';
            if (requestId && this.receivedResultIds.has(requestId)) return;
            const result = {
                source: 'remote-floating-chat',
                question: value.payload.question.trim(),
                answer: value.payload.answer,
                requestId
            };
            const prepared = this.preparedScenarioQuery;
            if (prepared && requestId === prepared.requestId
                && this.etchScenarioIndex(result.question) !== this.etchScenarioIndex(prepared.question)) return;
            if (!this.connected) {
                if (requestId && this.pendingResults.some(item => item.requestId === requestId)) return;
                // 완료 응답이 READY보다 먼저 도착할 수 있습니다. 검증된 내용만 보관합니다.
                this.pendingResults.push(result);
                if (this.pendingResults.length > 20) this.pendingResults.shift();
                return;
            }
            this.publishResult(result);
        } else if (value.type === 'CLOSE') {
            void this.closeChat();
        } else if (value.type === 'NAVIGATE') {
            const path = this.navigationPath(value.payload.path);
            if (!path) return;
            void this.closeChat();
            this.service.href(path);
        }
    }

    private async publishResult(result: any) {
        if (this.destroyed || !this.connected) return;
        const requestId = result.requestId;
        if (requestId && this.receivedResultIds.has(requestId)) return;
        const prepared = this.preparedScenarioQuery;
        const submittedScenario = requestId && this.scenarioRequestIds.has(requestId);
        const matchesPrepared = prepared && requestId === prepared.requestId
            && this.etchScenarioIndex(result.question) === this.etchScenarioIndex(prepared.question);
        if (prepared && requestId === prepared.requestId && !matchesPrepared) return;
        // 취소되었거나 이전 질문의 응답은 전달하되 현재 화면에 적용하지 않습니다.
        const skipScenario = submittedScenario ? !matchesPrepared : Boolean(prepared);
        if (requestId) {
            this.receivedResultIds.add(requestId);
            if (this.receivedResultIds.size > 200) {
                this.receivedResultIds.delete(this.receivedResultIds.values().next().value);
            }
        }
        if (skipScenario) result = { ...result, scenarioHandled: true };
        if (!skipScenario && this.isEtchScenarioQuestion(result.question)) {
            this.cancelScenarioQuery();
            await this.deliverScenarioEvent('nanofab-floating-chat-result', result);
            return;
        }
        window.dispatchEvent(new CustomEvent('nanofab-floating-chat-result', { detail: result }));
    }

    private async deliverScenarioEvent(eventName: string, detail: any) {
        const sequence = ++this.scenarioDeliverySequence;
        const instanceId = this.instanceId;
        const current = () => !this.destroyed && this.connected
            && instanceId === this.instanceId && sequence === this.scenarioDeliverySequence;
        let navigating = false;
        try {
            if (!this.isEtchMockupPath()) {
                navigating = true;
                ++this.scenarioNavigationCount;
                const navigated = await this.router.navigateByUrl(ETCH_MOCKUP_PATH);
                if (!navigated || !current() || !this.isEtchMockupPath()) return;
            }
            if (!current()) return;
            window.dispatchEvent(new CustomEvent(eventName, { detail }));
        } catch (_error) {
            // 취소되거나 실패한 이동은 다른 화면에 시나리오를 적용하지 않습니다.
        } finally {
            if (navigating) --this.scenarioNavigationCount;
        }
    }

    private async publishScenarioFallback() {
        const query = this.preparedScenarioQuery;
        if (this.destroyed || !this.connected || !this.scenarioFallbackExpired
            || !query || this.etchScenarioIndex(query.question) !== 3) return;
        this.cancelScenarioQuery();
        // 화면 전환만 수행합니다. 챗봇의 실제 답변을 생성하거나 완료로 표시하지 않습니다.
        await this.deliverScenarioEvent('nanofab-floating-chat-scenario', {
            ...query, trigger: 'response-timeout'
        });
    }

    private prepareScenarioQuery(query: any) {
        const index = this.etchScenarioIndex(query.question);
        for (let i = this.pendingResults.length - 1; i >= 0; --i) {
            const result = this.pendingResults[i];
            if (result.requestId === query.requestId && this.etchScenarioIndex(result.question) !== index) {
                this.pendingResults.splice(i, 1);
            }
        }
        this.preparedScenarioQuery = query;
        this.scenarioLoading = true;
        const scene = [1, 2, 3, 7][index];
        // 완료 응답을 기다리는 동안 원본 이미지만 준비하고 현재 URL과 화면은 유지합니다.
        this.scenarioPreloadImages = (scene === 3 ? [3, 4] : [scene]).map(value => {
            const image = new Image();
            image.src = '/assets/mockups/식각 장비 ' + value + '.png';
            return image;
        });
        if (index === 3) {
            const sequence = this.scenarioDeliverySequence;
            const instanceId = this.instanceId;
            this.scenarioFallbackTimer = window.setTimeout(() => {
                if (this.destroyed || sequence !== this.scenarioDeliverySequence
                    || instanceId !== this.instanceId || this.preparedScenarioQuery !== query) return;
                this.scenarioFallbackTimer = null;
                this.scenarioFallbackExpired = true;
                if (this.connected) void this.publishScenarioFallback();
            }, 10000);
        }
        void this.service.render();
    }

    private cancelScenarioQuery() {
        ++this.scenarioDeliverySequence;
        window.clearTimeout(this.scenarioFallbackTimer);
        this.scenarioFallbackTimer = null;
        this.scenarioFallbackExpired = false;
        this.preparedScenarioQuery = null;
        this.scenarioPreloadImages = [];
        const wasLoading = this.scenarioLoading;
        this.scenarioLoading = false;
        if (wasLoading && !this.destroyed) void this.service.render();
    }

    private isEtchMockupPath() {
        if (location.pathname !== '/agent/screen-adjust') return false;
        const params = new URLSearchParams(location.search || '');
        return params.get('group') === '검색' && params.get('menu') === '데이터 검색';
    }

    private isEtchScenarioQuestion(question: string) {
        return this.etchScenarioIndex(question) >= 0;
    }

    private etchScenarioIndex(question: string) {
        // 원격 시나리오 판별과 동일하게 공백·구두점 표기 차이를 무시합니다.
        const normalize = (text: string) => text.normalize('NFC')
            .replace(/[.,!?。？！]/g, '').replace(/\s+/g, '').toLowerCase();
        return [
            '식각 공정에 사용하는 장비 목록을 보여줘',
            '실리콘 식각 장비를 선택해서 목록을 보여줘',
            '저 중에서 CMOS etcher를 보여줘',
            '저 중에서 프로파일 Y, Z축 값이랑 압력값, 온도값을 보여줘'
        ].findIndex(value => normalize(value) === normalize(question));
    }

    private validMessage(value: any) {
        try {
            if (!this.plainObject(value)
                || Object.keys(value).some(key => !['channel', 'version', 'type', 'requestId', 'instanceId', 'payload'].includes(key))
                || value.channel !== CHANNEL || value.version !== 1 || value.instanceId !== this.instanceId
                || !this.plainObject(value.payload)
                || (value.requestId != null && (typeof value.requestId !== 'string' || !/^req-[0-9a-f]{32}$/.test(value.requestId)))
                || new TextEncoder().encode(JSON.stringify(value)).length > 65536) return false;
            if (value.type === 'RESULT') {
                const payload = value.payload;
                return typeof payload.question === 'string' && payload.question.trim().length > 0
                    && payload.question.length <= 2000
                    && typeof payload.answer === 'string' && payload.answer.trim().length > 0
                    && payload.answer.length <= 8000
                    && (payload.kind == null || (typeof payload.kind === 'string'
                        && !['error', 'progress', 'review', 'pending'].includes(payload.kind)))
                    && (payload.requestId == null || (typeof payload.requestId === 'string'
                        && /^req-[0-9a-f]{32}$/.test(payload.requestId)))
                    && (!value.requestId || !payload.requestId || value.requestId === payload.requestId);
            }
            if (value.type === 'QUERY_SUBMITTED') {
                const payload = value.payload;
                return typeof payload.question === 'string' && payload.question.trim().length > 0
                    && payload.question.length <= 2000
                    && typeof (value.requestId || payload.requestId) === 'string'
                    && /^req-[0-9a-f]{32}$/.test(value.requestId || payload.requestId)
                    && (payload.requestId == null || (typeof payload.requestId === 'string'
                        && /^req-[0-9a-f]{32}$/.test(payload.requestId)))
                    && (!value.requestId || !payload.requestId || value.requestId === payload.requestId);
            }
            if (value.type === 'CONVERSATION_RESET') return Object.keys(value.payload).length === 0;
            if (value.type === 'READY') return true;
            if (value.type === 'CLOSE') return Object.keys(value.payload).length === 0;
            if (value.type === 'NAVIGATE') {
                return Object.keys(value.payload).length === 1
                    && typeof value.payload.path === 'string'
                    && Boolean(this.navigationPath(value.payload.path));
            }
            return false;
        } catch (_error) {
            return false;
        }
    }

    private navigationPath(value: any) {
        if (typeof value !== 'string' || value.length > 2048
            || !value.startsWith('/') || value.startsWith('//')
            || value.includes('#') || /[\u0000-\u001f\u007f]/.test(value)) return '';
        try {
            const url = new URL(value, location.origin);
            if (url.origin !== location.origin || url.username || url.password || url.hash) return '';
            if (!/^\/agent\/[a-z0-9_-]+$/.test(url.pathname) && !NAVIGATION_PATHS.includes(url.pathname)) return '';
            return url.pathname + url.search;
        } catch (_error) {
            return '';
        }
    }

    public async retryConnection() {
        this.connected = false;
        this.cancelScenarioQuery();
        this.scenarioRequestIds.clear();
        this.receivedResultIds.clear();
        this.pendingResults.length = 0;
        this.status = '챗봇 연결을 확인하고 있습니다.';
        window.clearTimeout(this.connectionTimer);
        window.clearInterval(this.handshakeTimer);
        this.frameCreated = false;
        this.prepareFrameUrl();
        await this.service.render();
        this.frameCreated = true;
        await this.service.render();
    }

    private plainObject(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
        const prototype = Object.getPrototypeOf(value);
        return prototype === Object.prototype || prototype === null;
    }

    private sendHostContext() {
        const target = this.frame?.nativeElement.contentWindow;
        if (!target || this.destroyed) return;
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        target.postMessage({
            channel: CHANNEL,
            version: 1,
            type: 'HOST_CONTEXT',
            requestId: 'req-' + Array.from(bytes).map(value => value.toString(16).padStart(2, '0')).join(''),
            instanceId: this.instanceId,
            payload: { context: {
                theme: document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light',
                path: location.pathname.slice(0, 300),
                title: document.title.slice(0, 300)
            } }
        }, CHAT_ORIGIN);
    }

    public resizeEnabled() { return window.innerWidth > 640; }

    public panelStyle() {
        return this.resizeEnabled() ? { width: this.width + 'px', height: this.height + 'px', maxHeight: 'none' } : {};
    }

    public resizeValue() { return '현재 너비 ' + this.width + '픽셀, 높이 ' + this.height + '픽셀'; }

    @HostListener('window:resize')
    public viewportResized() {
        this.clampSize();
        if (!this.resizeEnabled()) this.finishResize();
        void this.service.render();
    }

    public startResize(event: PointerEvent) {
        if (!this.resizeEnabled() || event.button !== 0 || this.resizing) return;
        event.preventDefault();
        event.stopPropagation();
        this.resizePointer = event.pointerId;
        this.resizeStart = { x: event.clientX, y: event.clientY, width: this.width, height: this.height };
        this.resizeHandle = event.currentTarget as HTMLElement;
        this.resizing = true;
        try { this.resizeHandle.setPointerCapture?.(event.pointerId); } catch (_error) { }
        window.addEventListener('pointermove', this.resizeMove);
        window.addEventListener('pointerup', this.resizeEnd);
        window.addEventListener('pointercancel', this.resizeEnd);
        void this.service.render();
    }

    private moveResize(event: PointerEvent) {
        if (!this.resizing || !this.resizeStart || event.pointerId !== this.resizePointer) return;
        event.preventDefault();
        this.width = this.resizeStart.width + this.resizeStart.x - event.clientX;
        this.height = this.resizeStart.height + this.resizeStart.y - event.clientY;
        this.clampSize();
        void this.service.render();
    }

    private finishResize(event?: PointerEvent) {
        if (event && this.resizePointer !== null && event.pointerId !== this.resizePointer) return;
        window.removeEventListener('pointermove', this.resizeMove);
        window.removeEventListener('pointerup', this.resizeEnd);
        window.removeEventListener('pointercancel', this.resizeEnd);
        try {
            if (this.resizePointer !== null && this.resizeHandle?.hasPointerCapture?.(this.resizePointer)) {
                this.resizeHandle.releasePointerCapture(this.resizePointer);
            }
        } catch (_error) { }
        const wasResizing = this.resizing;
        this.resizePointer = null;
        this.resizeStart = null;
        this.resizeHandle = null;
        this.resizing = false;
        if (wasResizing) {
            this.saveSize();
            if (!this.destroyed) void this.service.render();
        }
    }

    public resizeKeydown(event: KeyboardEvent) {
        if (!this.resizeEnabled()) return;
        const step = event.shiftKey ? 40 : 16;
        if (event.key === 'ArrowLeft') this.width += step;
        else if (event.key === 'ArrowRight') this.width -= step;
        else if (event.key === 'ArrowUp') this.height += step;
        else if (event.key === 'ArrowDown') this.height -= step;
        else if (event.key === 'Home') { this.width = 560; this.height = 760; }
        else return;
        event.preventDefault();
        event.stopPropagation();
        this.clampSize();
        this.saveSize();
        void this.service.render();
    }

    private clampSize() {
        if (!this.resizeEnabled()) return;
        const maximumWidth = Math.max(280, window.innerWidth - 44);
        const maximumHeight = Math.max(1, window.innerHeight - 44);
        this.width = Math.round(Math.max(Math.min(360, maximumWidth), Math.min(maximumWidth, this.width || 560)));
        this.height = Math.round(Math.max(Math.min(440, maximumHeight), Math.min(maximumHeight, this.height || 760)));
    }

    private restoreSize() {
        try {
            const saved = JSON.parse(localStorage.getItem(this.sizeKey) || '{}');
            if (Number.isFinite(Number(saved.width))) this.width = Number(saved.width);
            if (Number.isFinite(Number(saved.height))) this.height = Number(saved.height);
        } catch (_error) { }
        this.clampSize();
    }

    private saveSize() {
        try { localStorage.setItem(this.sizeKey, JSON.stringify({ width: this.width, height: this.height })); } catch (_error) { }
    }
}

export default ComponentChatbotRemoteComponent;